import _ from 'lodash'
import { Tag } from '@/admin-shared-modules/typings'
import { GET } from '@/admin-shared-modules/utils/ajax'

class TagSelectorStore {
  state = {
    flattenTags: [] as Tag[],
    items: [] as Tag[],
    loading: false
  }

  async fetch() {
    if (this.state.items.length) return
    this.state.loading = true

    try {
      const res = await GET('lms_course/tag', {})
      this.state.flattenTags = res.data
      this.state.items = this.state.flattenTags as Tag[]
    } catch (e) {
      console.error(e)
    } finally {
      this.state.loading = false
    }
  }

  getTagById(id: number) {
    return _.clone(_.find(this.state.flattenTags, { id }))
  }
}

export default new TagSelectorStore()
